import type { InternalNotifyOption } from '../types'

/** Primary action button chrome for the resident notify dialogs. */
export const NOTES_NOTIFY_DIALOG_BUTTON_CLASS =
  'w-full min-w-[140px] rounded-lg bg-[#1597ff] px-6 py-2.5 text-sm font-semibold text-white shadow-2xs transition hover:bg-[#0d7acc] disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500 disabled:shadow-none sm:w-auto'

/** Primary action button chrome for the Review Resident dialog (uses the themed `bg-button`). */
export const REVIEW_RESIDENT_DIALOG_BUTTON_CLASS =
  'w-full min-w-[120px] rounded-lg bg-button px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:brightness-110 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500 disabled:shadow-none disabled:hover:brightness-100 sm:w-auto'

/** Angular `resident-edit-new` internal-notes notify recipients — "Notify teams" group. */
export const INTERNAL_NOTIFY_TEAM_OPTIONS: InternalNotifyOption[] = [
  { value: 'default_manager', label: 'Reimbursements Team' },
  { value: 'customer_service', label: 'Customer Service' },
  { value: 'success_manager', label: 'Property Support Team' },
  { value: 'default_success', label: 'Reimbursements & Property Support Teams' },
]

/** Angular `resident-edit-new` internal-notes notify recipients — "Other actions" group. */
export const INTERNAL_NOTIFY_ACTION_OPTIONS: InternalNotifyOption[] = [
  { value: 'none', label: 'Save note only', subtitle: 'No notification will be sent' },
  { value: 'l1_review', label: 'L1 Review Recommendation', subtitle: 'Route for L1 review' },
]
